import { isBaseFunctionSupported } from "../../support";
import { SqlFunctionDisplayNames, SqlFunctionName } from "../constants";

export const getSqlFunctionTypes = (integration: string) =>
  (Object.keys(SqlFunctionDisplayNames) as SqlFunctionName[]).reduce<SqlFunctionName[]>(
    (acc, t) => (isBaseFunctionSupported(integration, t) ? [...acc, t] : acc),
    []
  );
